import { render } from "./AgentFormPage.vue?vue&type=template&id=181b4569"
import script from "./AgentFormPage.vue?vue&type=script&lang=js"
export * from "./AgentFormPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__